export default {
  contractsControllerLabelTemplate: process.env.VUE_APP_CONTRACTS_CONTROLLER_LABEL_TEMPLATE ?? null,
  apiUrl: !process.env["VUE_APP_API_URL_" + process.env.VUE_APP_API_ENV] ?
    window.location.protocol + "//" + window.location.hostname + "/" + process.env["VUE_APP_API_PATH_" + process.env.VUE_APP_API_ENV] + "/"
    : process.env["VUE_APP_API_URL_" + process.env.VUE_APP_API_ENV],
  chatUrl: !!process.env["VUE_APP_CHAT_URL_" + process.env.VUE_APP_API_ENV] ? process.env["VUE_APP_CHAT_URL_" + process.env.VUE_APP_API_ENV]
    : (!!process.env["VUE_APP_CHAT_PORT_" + process.env.VUE_APP_API_ENV] ? window.location.protocol + "//" + window.location.hostname + ":" + process.env["VUE_APP_CHAT_PORT_" + process.env.VUE_APP_API_ENV] + "/"
      : window.location.protocol + "//" + window.location.hostname + "/" + process.env["VUE_APP_CHAT_PATH_" + process.env.VUE_APP_API_ENV] + "/"),
  publicPath: process.env.NODE_ENV === "production" ? "/" + process.env["VUE_APP_PUBLIC_PATH_" + process.env.VUE_APP_API_ENV] + "/" : "/",
  version: process.env.VUE_APP_VERSION ?? "",
  emptyContractsInOpers: process.env.VUE_APP_OPER_USEEMPTYCONTRACT == "1",
  timeAccountEnableForFilter1: process.env.VUE_APP_TimeAccountEnableForFilter1 == "1",
  timeAccountEnableForFilter7: process.env.VUE_APP_TimeAccountEnableForFilter7 == "1",
  androidUrl: process.env.VUE_APP_ANDROID_URL ?? "",
  iosUrl: process.env.VUE_APP_IOS_URL ?? "",
  officesUrl: process.env.VUE_APP_OFFICES_URL ?? "",
  atmUrl: process.env.VUE_APP_ATM_URL ?? "",
  contactsUrl: process.env.VUE_APP_CONTACTS_URL ?? "",
  aboutBankUrl: process.env.VUE_APP_ABOUTBANK_URL ?? "",
  aboutSystemUrl: process.env.VUE_APP_ABOUTSYSTEM_URL ?? "",
  dateOld: process.env.VUE_APP_DATE_OLD ?? "",
  loginTypes: process.env.VUE_APP_LOGIN_TYPES ?? "login"
}